export default __webpack_public_path__ + "static/media/007-hospital-2.10a6b852.png";